 export const transactionStatuses = [
  { label: 'الكل', value: 'all' },
  { label: 'واردة', value: 'incoming' },
  { label: 'صادرة', value: 'outgoing' },
  { label: 'دين', value: 'debt' },
  { label: 'مدفوع', value: 'paid' },
];
